import { render, staticRenderFns } from "./VendorFeature.vue?vue&type=template&id=3b6c3deb&scoped=true&"
import script from "./VendorFeature.vue?vue&type=script&lang=js&"
export * from "./VendorFeature.vue?vue&type=script&lang=js&"
import style0 from "./VendorFeature.vue?vue&type=style&index=0&id=3b6c3deb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c3deb",
  null
  
)

export default component.exports